// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// 命名規則に従って Controller を読み込みます
// これにより以下の属性で stimulus の利用ができるようになります
// ※フォルダは -- で区切られることに注意
// ※アンダースコアは - に変換されるので注意
// @example
//   test_controller.js #=> data-controller="test"
//   hoge_hoge_controller.js #=> data-controller="hoge-hoge"
//   foo/bar_controller.js #=> data-controller="foo--bar"
//   foo_bar/baz_controller.js #=> data-controller="foo-bar--baz"
const context = require.context(".", true, /\.js$/)
application.load(definitionsFromContext(context))